/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Equipment_DumbbellsInputs */

const en_us2_onboarding_equipment_dumbbells = /** @type {(inputs: Onboarding_Equipment_DumbbellsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dumbbells`)
};

const pt_br2_onboarding_equipment_dumbbells = /** @type {(inputs: Onboarding_Equipment_DumbbellsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halteres`)
};

const es_419_onboarding_equipment_dumbbells = /** @type {(inputs: Onboarding_Equipment_DumbbellsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mancuernas`)
};

const pt_pt2_onboarding_equipment_dumbbells = /** @type {(inputs: Onboarding_Equipment_DumbbellsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halteres`)
};

const fr_fr2_onboarding_equipment_dumbbells = /** @type {(inputs: Onboarding_Equipment_DumbbellsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haltères`)
};

const de_de2_onboarding_equipment_dumbbells = /** @type {(inputs: Onboarding_Equipment_DumbbellsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurzhanteln`)
};

const it_it2_onboarding_equipment_dumbbells = /** @type {(inputs: Onboarding_Equipment_DumbbellsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manubri`)
};

/**
* | output |
* | --- |
* | "Dumbbells" |
*
* @param {Onboarding_Equipment_DumbbellsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_equipment_dumbbells = /** @type {((inputs?: Onboarding_Equipment_DumbbellsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Equipment_DumbbellsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_equipment_dumbbells(inputs)
	if (locale === "es-419") return es_419_onboarding_equipment_dumbbells(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_equipment_dumbbells(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_equipment_dumbbells(inputs)
	if (locale === "de-DE") return de_de2_onboarding_equipment_dumbbells(inputs)
	if (locale === "it-IT") return it_it2_onboarding_equipment_dumbbells(inputs)
	return en_us2_onboarding_equipment_dumbbells(inputs)
});
export { onboarding_equipment_dumbbells as "onboarding.equipment.dumbbells" }